import {
	SET_AVAILABLE_ASSETS,
	SHOW_ERROR_MESSAGE,
	RESET_STATE,
	SHOW_SUCCESS_MESSAGE,
	CLEAR_SELECTED_ASSETS,
	CLEAR_SELECTED_STATUSES,
	TOGGLE_SELECT_ALL_ASSETS,
	HIDE_TOAST_MESSAGE,
	TOGGLE_SELECT_ALL_STATUSES,
	CLEAR_FILTERS
} from "./AlarmsActionsType";

export default {
	/**
   * Altera o state do toast message para exibir uma mensagem de erro.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {string} message - Mensagem de erro a ser exibida.
   */
	[SHOW_ERROR_MESSAGE]({ commit }, message)
	{
		commit(SHOW_ERROR_MESSAGE, message);
	},

	/**
		 * Define os ativos disponíveis e guarda no state do modulo.
		 *
		 * @param {Object} context - O contexto Vuex.
		 * @param {Array} assets - Lista de ativos disponíveis.
		 */
	[SET_AVAILABLE_ASSETS]({ commit }, assets)
	{
		commit(SET_AVAILABLE_ASSETS, assets);
	},

	/**
   * Altera o state do toast message para exibir uma mensagem de sucesso.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {string} message - Mensagem de sucesso a ser exibida.
   */
	[SHOW_SUCCESS_MESSAGE]({ commit }, message)
	{
		commit(SHOW_SUCCESS_MESSAGE, message);
	},

	/**
	 * Altera o state do toast message para esconder a mensagem no front.
	 *
	 * @param {Object} context - O contexto Vuex.
	 */
	[HIDE_TOAST_MESSAGE]({ commit })
	{
		commit(HIDE_TOAST_MESSAGE);
	},

	/**
   * Reseta o state da store para seu estado inicial.
   */
	[RESET_STATE]({ commit })
	{
		commit(RESET_STATE);
	},

	/**
   * Limpa as turbinas selecionados no filtro.
   */
	[CLEAR_SELECTED_ASSETS]({ commit })
	{
		commit(CLEAR_SELECTED_ASSETS);
	},

	/**
   * Limpa os status selecionados no filtro.
   */
	[CLEAR_SELECTED_STATUSES]({ commit })
	{
		commit(CLEAR_SELECTED_STATUSES);
	},

	/**
   * Alterna a seleção de todos os assets no filtro (selecionar todos ou nenhum).
   */
	[TOGGLE_SELECT_ALL_ASSETS]({ commit })
	{
		commit(TOGGLE_SELECT_ALL_ASSETS);
	},

	/**
   * Alterna a seleção de todos os statuses no filtro (selecionar todos ou nenhum).
   */
	[TOGGLE_SELECT_ALL_STATUSES]({ commit })
	{
		commit(TOGGLE_SELECT_ALL_STATUSES);
	},

	/**
   * Limpa todos os filtros aplicados (turbinas e status).
   */
	[CLEAR_FILTERS]({ commit })
	{
		commit(CLEAR_FILTERS);
	}
};
